export const SEASON_START_ROUND_ID = 1;
